<template>
  <ChecklistActivityFormEmbeddable :activity-number="4"/>
</template>
<script>
import ChecklistActivityFormEmbeddable from "@/views/modules/checklist/ChecklistActivity/embeddable/ChecklistActivityFormEmbeddable";

export default {
  components: {ChecklistActivityFormEmbeddable},
  name: 'ChecklistActivity1Form',
}
</script>

